import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, TYPOGRAPHY } from '../../lib/styleGuide';
import { TickSquare, Bag, ArrowRight } from 'react-iconly';

const SUCCESS_GREEN = '#10B981';

export default function OnboardingSuccess() {
  const navigate = useNavigate();

  const goToStorefront = () => {
    navigate('/store-preview');
  };

  const goToDashboard = () => {
    navigate('/seller-hub');
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center', 
      background: '#FAFAFA',
      padding: '20px'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: 700, 
        background: '#fff',
        borderRadius: 20,
        boxShadow: '0 8px 32px #0001',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{ 
          background: COLORS.PRIMARY_GRADIENT, 
          padding: '40px',
          textAlign: 'left'
        }}>
          <h1 style={{ 
            fontWeight: 700, 
            fontSize: '28px', 
            margin: 0, 
            color: '#fff' 
          }}>
            Welcome to Vesta!
          </h1>
        </div>

        {/* Content */}
        <div style={{ padding: '40px', textAlign: 'left' }}>
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ 
              fontWeight: 600, 
              fontSize: '24px', 
              margin: '0 0 16px 0', 
              color: '#222' 
            }}>
              🎉 You're All Set!
            </h2>
            <p style={{ 
              fontSize: '14px', 
              color: '#666', 
              margin: '0 0 24px 0',
              lineHeight: 1.6,
              maxWidth: 500
            }}>
              Congratulations! You've successfully completed the onboarding process. Your identity verification is currently being reviewed and we'll notify you once it's complete.
            </p>
            
            <div style={{ 
              background: '#F8F9FA', 
              borderRadius: 16, 
              padding: '24px',
              border: '1px solid #E9ECEF',
              marginBottom: '32px'
            }}>
              <h3 style={{ 
                fontWeight: 600, 
                fontSize: '20px', 
                margin: '0 0 16px 0', 
                color: '#222' 
              }}>
                What's Next?
              </h3>
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '16px',
                textAlign: 'left',
                maxWidth: 400
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ 
                    width: '24px', 
                    height: '24px', 
                    background: COLORS.PRIMARY_GRADIENT, 
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 600
                  }}>
                    1
                  </div>
                  <span style={{ fontSize: '14px', color: '#666' }}>
                    Wait for identity verification to complete
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ 
                    width: '24px', 
                    height: '24px', 
                    background: COLORS.PRIMARY_GRADIENT, 
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 600
                  }}>
                    2
                  </div>
                  <span style={{ fontSize: '14px', color: '#666' }}>
                    Upload any required files or documents
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ 
                    width: '24px', 
                    height: '24px', 
                    background: COLORS.PRIMARY_GRADIENT, 
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 600
                  }}>
                    3
                  </div>
                  <span style={{ fontSize: '14px', color: '#666' }}>
                    Set up your store profile and branding
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button
              onClick={goToDashboard}
              style={{
                background: COLORS.PRIMARY_GRADIENT,
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                padding: '16px 32px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                minHeight: 56,
                minWidth: 200,
                boxShadow: '0 4px 12px #0002',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              <ArrowRight set="regular" size={24} primaryColor="#fff" />
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
